import React from 'react'
import MaterialSymbol from '../material-symbol'

const Sync = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="sync" {...props} />
))

Sync.displayName = 'Sync'

export default Sync
